/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".nameUnit[_ngcontent-%COMP%]{color:#555}.defaultFont[_ngcontent-%COMP%]    {padding-left:30px;margin:5px 0;color:#aaaab0;font-size:18px}"];
export { styles as styles };
